class FacilityInfo {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector("." + this.el)) {
      this.event();
    }
  }
  event() {
    const infoWrap = document.querySelector("." + this.el);
    gsap.to(infoWrap,{
      opacity: 0,
      scrollTrigger: {
        trigger: 'footer',
        start: 'top bottom',
        end: 'top 95%',
        scrub: 1,
        onEnter: () => {
          infoWrap.style.pointerEvents = 'none'
        },
        onEnterBack: () => {
          infoWrap.style.pointerEvents = 'auto'
        }
      },
    })
  }
}
